import 'twin.macro';
import React from 'react';
import { ReactComponent as Icon } from './magic-wand.svg';
import { IconProps } from '@teetsh/app/src/components/Icons/icon';

export default function MagicWandIcon(props: IconProps) {
  return <Icon tw="fill-current" className={props.className} />;
}
